import * as R from "ramda";
import { func, number } from "prop-types";
import cx from "classnames";

import { legendStateType } from "./legendState.js";
import { navigateToMapEntity } from "../../common/mapUrl.js";
import { MAX_ZOOM, MIN_ZOOM } from "./GoogleMap.jsx";
import { getDataIconImg } from "../../common/dept.jsx";

import "./map-overlay.scss";

const propTypes = {
  legends: legendStateType.isRequired,
  onLegendChange: func,
  setZoom: func,
  zoom: number,
};

const MapOverlay = (props) => {
  const { legends, onLegendChange, setZoom, zoom } = props;

  if (R.anyPass([R.isNil, R.isEmpty])(legends)) {
    return null;
  }

  return (
    <div className="map-overlay">
      <div className="map-overlay__legend">
        {legends.map((legend) => {
          const { id, isActive, label } = legend;

          return (
            <button
              key={id}
              type="button"
              className={cx("map-overlay__legend-item", {
                "map-overlay__legend-item--is-inactive": !isActive,
              })}
              onClick={() => onLegendChange(id)}
            >
              <div
                className={cx("map-overlay__icon", `map-overlay__icon--${id}`)}
              >
                {getDataIconImg(id)}
              </div>{" "}
              {label}
            </button>
          );
        })}
      </div>

      <div
        className={cx("map-overlay__non-conus-states", {
          "map-overlay__non-conus-states--hidden": zoom > 4,
        })}
      >
        <button
          type="button"
          onClick={() => navigateToMapEntity("HI")}
          className="map-overlay__hawaii"
        >
          {hawaii} Hawaii
        </button>
        <button
          type="button"
          onClick={() => navigateToMapEntity("AK")}
          className="map-overlay__alaska"
        >
          {alaska} Alaska
        </button>
      </div>

      {setZoom && (
        <div className="map-overlay__zoom">
          <button
            type="button"
            className="map-overlay__zoom-in"
            onClick={() => setZoom((zoom) => zoom + 1)}
            disabled={zoom >= MAX_ZOOM}
            title="Zoom in"
            aria-label="Zoom in"
          >
            {plus}
          </button>
          <button
            type="button"
            className="map-overlay__zoom-out"
            onClick={() => setZoom((zoom) => zoom - 1)}
            disabled={zoom <= MIN_ZOOM}
            title="Zoom out"
            aria-label="Zoom out"
          >
            {minus}
          </button>
        </div>
      )}
    </div>
  );
};

MapOverlay.propTypes = propTypes;
export default MapOverlay;

const plus = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-plus"
  >
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
);

const minus = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-minus"
  >
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
);

const alaska = (
  <svg width="27" height="24" viewBox="0 0 20 18">
    <path
      fill="currentColor"
      d="M8.813.331L9 .881l.198-.193.617.155-.056.256.552.26.397-.071.766.426.727.155.288.162.518-.162.576.352.419.16-.019 4.044-.027 5.868.49.028.49.272.36.43.472.638.473-.575.49-.348.298.498.37.383.505.41.384.676.644 1.06.982.518.086.604-.253.498-.343-.328-.514-.259-.232-.828-.755-.727-.352-.903-.504-.03-.827.02-.618-.262-1.078-1.009-.484-.187-.873-.367-.695.065-.956-.506-.558-.466-.561.17.045.703-.282.04-.599.153-.478.288-.584.144v-.591l.34-.948.554-.25-.106-.266-.686.485-.42.62-.82.6.301.53-.586.633-.62.319-.57.207-.204.404-.915.342-.256.415-.71.278-.352-.152-.56.15-.621.191-.527.202-.998.022-.042-.179.704-.277.598-.155.693-.376.683.044.347-.332.847-.419.155-.169.45-.265.226-.716.365-.527-.639.185-.13-.199-.345.297-.227-.56-.21.318-.083-.523-.587.273-.308-.073.095-.584.174-.334-.231-.422-.68.026-.287-.563-.264-.322.15-.55-.242-.516.34-.51.525-.446.3-.465.383.024.268.239.483-.393.305.164.414-.234.022-.482-.204-.24.414-.318-.27-.05-.515.111-.19.191-.287-.31-.645-.05-.565-.421-.06-.458-.354-.748.713-.248 1.062-.242.339.09-.191.5.894.18-.183-.725-.403-.524-.148-.599-.258-.552-.442-.486.378-.49.69.154.61-.363.223-.505.508-.426.39-.042.804-.342.322.142L8.3 0l.513.331zM.157 6.334l.202.28.306-.007.266.377.395.273-.07.096-.404.098-.266-.325-.107-.234-.405-.078L0 6.692l.157-.358zm1.619 4.646l-.34.065-.263-.272-.212-.347.52-.025.354.196-.06.383zm5.795 4.022l-.58.293-.233-.29-.01-.466.524-.273.298-.11.335.113.182.331-.516.402z"
    />
  </svg>
);

const hawaii = (
  <svg width="27" height="18" viewBox="0 0 27 18">
    <g fill="currentColor">
      <path d="M.352 2.113c.118-.176.176-.323.352-.41.059-.03.118-.03.176-.089.06-.059.06-.117.147-.147.088-.058.206-.088.206.03 0 .058-.088.117-.118.176-.03.088.03.147.03.235-.06.146-.206.088-.294.117-.117.059-.176.147-.235.264-.058.088-.088.264-.234.176-.118-.058-.118-.264-.03-.352.088-.117-.088.088 0 0zM2.524 1.262c0-.147.117-.235.176-.352.059-.118.059-.176.176-.264.147-.088.352-.118.499-.206.117-.058.176-.147.293-.147l.118.06c.059 0 .147-.03.205-.03.176-.03.382-.059.558 0a.685.685 0 01.293.352c.03.059.03.176 0 .235-.029.117-.058.058-.088.147-.058.146 0 .322-.058.47-.03.028-.059.058-.088.058-.03.03-.03.088-.06.117-.175.264-.41.352-.703.294-.147-.03-.382-.03-.529-.088-.058-.03-.088-.118-.146-.147-.206-.206-.529-.147-.646-.499.03-.176.059.176 0 0zM9.89 3.668c.176 0 .382.03.558-.058.205-.088.352-.235.499-.411.41-.44.557.03.733.381.088.177.235.206.265.411.029.176.029.235.146.382.059.059.176.205.264.059.03-.06-.088-.089 0-.147.03-.03.147.03.177 0-.118.147 0 .176.058.323.03.058 0 .146.03.176.029.088.117.088.146.146.088.118.03.235-.117.265-.059.029-.147-.03-.206 0-.088 0-.146.088-.234.088-.176 0-.235-.147-.352-.235-.06-.03-.089-.088-.147-.118-.059 0-.147.088-.176.06-.088-.06 0-.148 0-.236-.03-.205-.118-.088-.206-.029-.03 0-.176.03-.205.059-.03.088.205.088.176.176-.03.058-.499.117-.587.088-.117-.059-.117-.176-.176-.294-.059-.146-.147-.234-.235-.352-.059-.117-.176-.235-.205-.352-.088-.147-.118-.264-.206-.382.352-.029.059.089 0 0zM14.615 5.958c.088-.088.147-.176.206-.265 0-.029 0-.117.029-.117.088-.088.235.03.352.059.323.088.705.147.998-.03.03-.029.147.118.176.118.088.03.176.059.264.059.176 0 .323-.03.47-.03.557-.03.088.411-.147.528-.47.235-.968-.088-1.438-.146-.235-.03-.47.058-.704.029-.088-.03-.353-.059-.206-.205.059-.06-.205.176 0 0zM15.79 7.16c0-.263.469-.175.615-.117a.7.7 0 01.323.177c.088.088.235.264.235.381 0 .264-.587.499-.763.294-.088-.118-.03-.294-.117-.411-.06-.118-.294-.147-.294-.323zM17.609 9.04c.146-.089.381-.382.557-.324.118.059.118.264.03.323-.059.059-.323.088-.411.088-.088 0-.323-.03-.147-.117 0 0-.059.03-.03.03.06-.06-.058.028 0 0zM18.665 7.836c0-.147-.117-.206-.264-.176-.03 0-.059.088-.117.088-.059 0-.206-.03-.235-.059-.206-.117-.44-.381-.499-.616-.03-.206.059-.323.205-.47.147-.117.235-.146.382-.03.293.206.293.705.734.5.205-.088.352-.176.557-.176.088 0 .147 0 .235.03.147.058.117.087.205.175.118.118.294.147.411.235.03.03.03.088.059.117.059.059.147.059.235.118.117.058.323.088.381.235.088.205-.117.264-.205.381-.03.03-.059.147-.088.176-.059.03-.176.03-.264.059-.206.059-.411.088-.587.147-.294.088-.734.381-.998.117-.059-.059-.088-.088-.088-.147 0-.058.059-.147.03-.176.029-.176-.089-.323-.089-.528zM23.772 15.965c.323-.058.499-.352.88-.352.382 0 .646-.176.998-.323.352-.147.646-.44.91-.675.323-.293.147-.47-.176-.645-.147-.088-.294-.177-.382-.323-.059-.118-.03-.294-.117-.411-.118-.147-.264 0-.382-.088-.146-.088-.117-.294-.117-.411 0-.147 0-.235-.088-.323a4.25 4.25 0 00-.528-.499c-.294-.264-.705-.41-1.086-.557-.382-.176-.763-.235-1.116-.411-.176-.088-.264-.118-.381-.264-.088-.118-.235-.147-.382-.176-.352-.06-.528.205-.381.528.088.264.499.616.264.91-.088.117-.176.176-.264.293-.03.059-.059.147-.088.205-.059.089-.118.089-.206.118-.264.117-.528.47-.41.734.146.293.293.557.381.88.117.352.323.675.382 1.057.058.41-.323.968-.03 1.32.118.147.323.235.47.352.147.118.352.176.499.294.176.117.176.205.352.03.117-.118.176-.324.264-.47.059-.147.117-.294.205-.411.147-.206.382-.206.529-.382.146-.03-.147.176 0 0z" />
    </g>
  </svg>
);
